export const AUTH_PASSWORD_FIELD_SHOW_PASSWORD_LABEL = 'Show password';
export const AUTH_PASSWORD_FIELD_HIDE_PASSWORD_LABEL = 'Hide password';
